'use client';

import { CommonImage } from '@/components/common';

interface EventGalleryProps {
  images: { url: string }[];
  isVideoAvailable: boolean;
}

const EventGallery = ({ images, isVideoAvailable }: EventGalleryProps) => {
  if (!images?.length) return null;

  const filteredImages = !isVideoAvailable
    ? images.filter((_, idx) => idx !== 0)
    : images;

  if (!filteredImages.length) return null

  function chunkArray<T>(array: T[], size: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }

  const renderSingleRow = () => (
    <div className='hide-scrollbar grid max-w-full snap-x snap-mandatory grid-flow-col gap-4 overflow-x-auto scroll-smooth pb-4'>
      {filteredImages.map((image, idx) => (
        <div
          key={idx}
          className='relative aspect-[2] flex-shrink-0 snap-start overflow-hidden rounded-lg shadow transition-transform duration-300 hover:scale-[1.02]  lg:w-[380px]'
        >
          <CommonImage
            src={image.url}
            alt={`Event image ${idx + 1}`}
            fill
            className='object-cover'
            sizes='(max-width: 768px) 90vw, (max-width: 1200px) 30vw, 380px'
            loading='lazy'
          />
        </div>
      ))}
    </div>
  );

  const renderTwoRows = () => (
    <div className='hide-scrollbar snap-x snap-mandatory overflow-x-auto scroll-smooth pb-4'>
      <div className='grid auto-cols-max grid-flow-col gap-4'>
        {chunkArray(filteredImages, 2).map((columnImages, colIdx) => (
          <div
            key={colIdx}
            className='flex w-[260px] flex-shrink-0 snap-start flex-col gap-4 md:w-[320px] lg:w-[380px]'
          >
            {columnImages.map((image, idx) => (
              <div
                key={idx}
                className='relative aspect-[2] overflow-hidden rounded-lg shadow transition-transform duration-300 hover:scale-[1.02]'
              >
                <CommonImage
                  src={image.url}
                  alt={`Event image ${colIdx * 2 + idx + 1}`}
                  fill
                  className='object-cover'
                  sizes='(max-width: 768px) 90vw, (max-width: 1200px) 30vw, 380px'
                  loading='lazy'
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <section className='mx-auto w-full max-w-7xl '>
      <h2 className='mb-4 text-xl font-bold text-gray-900'>Gallery</h2>
      {filteredImages.length < 3 ? renderSingleRow() : renderTwoRows()}
    </section>
  );
};

export default EventGallery;
